module.exports = __webpack_public_path__ + "media/images/lp_consultation/arrow-select-d94a71ef0c8afa206ff3dc2ac8dc6639.svg";